export class ListStagingBucketsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "buckets",
            "baseName": "buckets",
            "type": "Array<StagingBucket>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListStagingBucketsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
